
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class MarkupChargesGrid extends Serenity.EntityGrid<MarkupChargesRow, any> {
        protected getColumnsKey() { return 'OMS.MarkupCharges'; }
        protected getDialogType() { return MarkupChargesDialog; }
        protected getIdProperty() { return MarkupChargesRow.idProperty; }
        protected getInsertPermission() { return MarkupChargesRow.insertPermission; }
        protected getLocalTextPrefix() { return MarkupChargesRow.localTextPrefix; }
        protected getService() { return MarkupChargesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}